import type { PropsWithChildren } from "react";
import { useEffect } from "react";
import { useFormContext } from "react-hook-form";
import { classNames } from "@circle-react/helpers/twMergeWithCN";
import { Typography } from "@circle-react-shared/uikit/Typography";
import { Container } from "../../components/Container";
import { RowSidebar } from "../../components/RowSidebar";
import { HeaderForm } from "./HeaderForm";

type HooksParameter = Pick<
  ContainerFormProps,
  "toggleName" | "containerDataTestId"
>;

interface ContainerFormProps {
  containerClassName?: string;
  containerDataTestId: string;
  descriptionDataTestId?: string;
  descriptionLocale?: string;
  titleLocale?: string;
  toggleDataTestId?: string;
  toggleName?: string;
  useHooks?: (props: HooksParameter) => void;
}

export const useContainerEnabledForm = () => {};
export const useContainerForm = ({
  toggleName,
  containerDataTestId,
}: HooksParameter): void => {
  const { watch } = useFormContext();

  const isEnabled = watch(toggleName ?? "");
  useEffect(() => {
    const component = document.querySelector(
      `[data-testid='${containerDataTestId}']`,
    );
    if (!isEnabled) {
      component && component.setAttribute("inert", "");
    } else {
      component && component.removeAttribute("inert");
    }
  }, [isEnabled, containerDataTestId]);
};

export const ContainerForm = ({
  titleLocale,
  descriptionLocale,
  descriptionDataTestId,
  toggleDataTestId,
  containerDataTestId,
  children,
  toggleName,
  containerClassName,
  useHooks = useContainerForm,
}: PropsWithChildren<ContainerFormProps>) => {
  useHooks({ toggleName, containerDataTestId });

  return (
    <>
      {titleLocale && (
        <HeaderForm
          titleLocale={titleLocale}
          toggleName={toggleName}
          dataTestId={toggleDataTestId}
        />
      )}
      {descriptionLocale && (
        <RowSidebar dataTestId={descriptionDataTestId}>
          <Typography.BodySm>{descriptionLocale}</Typography.BodySm>
        </RowSidebar>
      )}
      <Container
        className={classNames(
          "h-[calc(100%-3.823rem-3.972rem-4.784rem)] overflow-y-auto p-0 pb-8 pt-5",
          containerClassName,
        )}
        dataTestId={containerDataTestId}
      >
        {children}
      </Container>
    </>
  );
};
